export { SaleFacet } from './SaleFacet';
